<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Motivos Preço Negociado">
      <crud-base
        :url="url"
        :columns="columns"
        :onDelete="() => {}"
        :onUpdate="() => {}"
        :onStore="() => {}"
        :enableSearch="true"
        :checkAlerts="true"
        :formInputs="formInputs"
        primaryKey="id"
      />
    </CTab>
  </CTabs>
</template>

<script>
import CrudBase from "../../components/crud/CrudBase";
import { schemaTextField, schemaBooleanSelect } from "@/helpers/form";
import { yesNoRepresentation } from "@/helpers/transformers";

export default {
  name: "PrecoNegociadoMotivo",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/preco-negociado-motivo",
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "DESCRIÇÃO", field: "descricao", sortable: false },
        {
          label: "CONCORRENTE",
          field: "concorrente",
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.concorrente),
        },
        {
          label: "ATIVO",
          field: "ativo",
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.ativo),
        },
      ],
      formInputs: {
        id: schemaTextField("Cód.", true, 3),
        descricao: schemaTextField("Descrição", true, 5),
        concorrente: schemaBooleanSelect("Concorrente", true, 2, 1, 0),
        ativo: schemaBooleanSelect("Ativo", true, 2, 1, 1),
      },
    };
  },
};
</script>
